import { resolveItemPartner } from './resolveItemPartner'
import { resolveItemRewardCategoryId } from './resolveItemRewardCategory'
import { sortStoreCatalogItemsByCoin } from '@/shared/lib/array/sort-store-catalog-by-coin'
import { isSoldOut } from './stock'
import { itemPrice } from './redeemBlock'
import type {
  StoreAdvancedFilters,
  StoreCatalogItem
} from './types'

type PartnerLookup = Record<string, string>

// O mesmo `isSoldOut` de `lib/stock`, sob o nome que a lojinha usa — não é uma
// segunda definição, e também não é "o" critério de esgotado do app: `Card.jsx`
// chama `isSoldOut` direto, `home/blocks/system/StoreBlock.tsx` e
// `features/quests/model/rewardEligibility.ts` têm os seus, e nenhum dos três
// conta `quantity` nulo como esgotado. Este nome marca quem compartilha a
// definição que espelha o servidor: a listagem e o detalhe da lojinha.
export { isSoldOut as isStoreItemSoldOut } from './stock'

export type StoreCatalogFilterCriteria = {
  search: string
  advanced: StoreAdvancedFilters
  walletCoins: number
  walletReady: boolean
  isAvailable: (item: StoreCatalogItem) => boolean
  partnerNameById?: PartnerLookup
}

export const filterStoreCatalogItems = (
  items: StoreCatalogItem[],
  criteria: StoreCatalogFilterCriteria
): StoreCatalogItem[] => {
  const query = criteria.search.trim().toLowerCase()
  const {
    advanced,
    walletCoins,
    walletReady,
    isAvailable,
    partnerNameById
  } = criteria

  const filtered = items.filter(item => {
    const soldOut = isSoldOut(item)

    if (!advanced.soldOut && soldOut) {
      return false
    }

    if (query && !item.name.toLowerCase().includes(query)) {
      return false
    }

    if (advanced.available && !isAvailable(item)) {
      return false
    }

    if (advanced.requested && item._requests.length === 0) {
      return false
    }

    if (advanced.affordable && walletReady) {
      // O preço vem da categoria; ler `coin` aqui escondia item precificado de
      // quem tinha saldo (a coluna legada já não é preenchida) e mostrava item
      // caro para quem não tem.
      if (itemPrice(item) > walletCoins) return false
      if (item.quantity != null && soldOut) return false
    }

    if (advanced.partnerId) {
      const partner = resolveItemPartner(item, partnerNameById)
      if (partner?.id !== advanced.partnerId) return false
    }

    if (advanced.categoryId) {
      const categoryId = resolveItemRewardCategoryId(item)
      if (categoryId !== advanced.categoryId) return false
    }

    return true
  })

  return sortStoreCatalogItemsByCoin(filtered)
}
